<template>

    <div class="auth__office-item auth__office-item--notice mobileBar">

        <div class="auth__office-item--client">
            <a href="#" @click.prevent=" open = !open" class="auth-user__open-btn">
                <span class="auth-user__open-icon"></span>
            </a>
        </div>
        <transition name="slide">
            <div id="mobBar" class="auth-user" v-if="open">
                <div v-if="user">
                    <div class="auth-user__header d-flex">
                        <a href="#" @click.prevent="open = false" class="auth-user__close">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 9L5 5M9 1L5 5M5 5L9 9M5 5L1 1" stroke="#929292" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        </a>
                        <a :href="`/user/${user.id}/profile`" class="auth-user__img">
                            <img :src="user.avatar" :alt="user.name" v-if="user.avatar">
                            <span v-else v-text="getUserPM(user)"></span>
                        </a>
                        <div class="auth-user__title">
                            <div class="auth-user__name" v-text="user.name"></div>
                            <span
                                class="auth-user__subtitle">{{ user.organization ? user.organization.name : profileType === 'zooprotection' ? 'Volunteer' : 'Donor' }}</span>
                        </div>
                    </div>
                    <div class="auth-user__widgets d-flex">
<!--                        <a href="http://journal.saveus.by/spravka"
                           class="auth__office-link auth__office-link&#45;&#45;toggle-size" target="_blank">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="8" r="7.45" stroke="#929292" stroke-width="1.1"/>
                                <path
                                    d="M7.89857 5.14493C7.67554 5.14493 7.48645 5.07425 7.3313 4.93288C7.18585 4.78142 7.11312 4.59461 7.11312 4.37247C7.11312 4.15032 7.18585 3.96857 7.3313 3.8272C7.48645 3.67574 7.67554 3.60001 7.89857 3.60001C8.1216 3.60001 8.30585 3.67574 8.4513 3.8272C8.60645 3.96857 8.68403 4.15032 8.68403 4.37247C8.68403 4.59461 8.60645 4.78142 8.4513 4.93288C8.30585 5.07425 8.1216 5.14493 7.89857 5.14493ZM6.40039 11.5973H7.50585V7.25026H6.41494V6.44751H8.56766V11.5973H9.60039V12.4H6.40039V11.5973Z"
                                    fill="#929292"/>
                            </svg>
                        </a>-->
                        <notice/>
                        <!--                        <messages :data="messages" :messageProp="messageProp"/>-->
                    </div>
                    <div class="auth-user__body">
                        <div class="notice__item-office">
                            <ul class="auth-user__list">
                                <li class="auth-user__item">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('profile-component')">
                                        <span class="auth-user__icon profile"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_profile')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('notification-component')">
                                        <span class="auth-user__icon notice"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_notifications')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('dashboard-component')">
                                        <span class="auth-user__icon dashboard"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_dashboard')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('settings-component')">
                                        <span class="auth-user__icon setting"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_profile_settings')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item" v-if="profileType === 'basic'">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('pets-component')">
                                        <span class="auth-user__icon notice"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_ads')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                    <a href="#" class="auth-user__link"
                                       @click.prevent="redirect('pets-component')">
                                        <span class="auth-user__icon less"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_my_wards')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                    <a :href="'/publication'" class="auth-user__link">
                                        <span class="auth-user__icon add"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_publish_card')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                    <a :href="`/volunteer/${user.id}/finance-report`" class="auth-user__link">
                                        <span class="auth-user__icon transaction"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_transactions')}}</span>
                                    </a>
                                </li>
                                <li class="auth-user__item">
                                    <a href="/auth/logout" @click="resetState" class="auth-user__link">
                                        <span class="auth-user__icon exit"></span>
                                        <span class="auth-user__label">{{$store.getters.t('main_menu_logout')}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>


</template>

<script>

import {mapGetters, mapMutations} from 'vuex'

import Notice from "./Notice";
import Messages from "./Messages";

export default {
    name: "MobileBar",
    components: {
        Notice,
        Messages
    },
    props: [
        'messages'
    ],
    data() {
        return {
            open: false,
            messageProp: true,
            appRoutes: null
        }
    },

    created() {
        this.appRoutes = window.appRoutes;
    },

    mounted() {
    },

    methods: {
        ...mapMutations({
            setComponent: 'setterProfileTab',
            resetState: 'resetDashboard'
        }),

        getUserPM(user) {
            let nameArray = user.name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        async redirect(component){

            if(window.location.href.indexOf(`/user/${this.user.id}/profile`) === -1){
                window.location.href = await ( window.location.origin + `/user/${this.user.id}/profile` )
            }

            await this.setComponent(component)

        },
    },

    computed: {
        user() {
            return this.$store.getters.getUserData
        },
        ...mapGetters({
            profileType: 'getUserProfileType',
        })
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/helpers';

.auth-user {
    color: #333333;
    font-size: 12px;
    line-height: 1;
    position: fixed;
    width: 250px;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);

    &__open-btn {
        display: block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        padding: 5px;
        text-align: center;
        background: $primaryBlue;
        border-radius: 100%;
        overflow: hidden;
        transition: opacity .2s ease;
        margin-top: -4px;

        .auth-user__open-icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            background: transparent url("/images/user-logged.svg") no-repeat center/contain;
        }

        &:hover {
            opacity: .8;
        }
    }

    &__close {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        padding: 10px;
    }

    &__header {
        background-color: #EFF1F3;
        padding: 30px 22px 15px 22px;
        font-weight: 700;
        align-items: center;
    }

    &__img {
        position: relative;
        width: 32px;
        min-width: 32px;
        margin-right: 10px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-weight: 700;
        background-color: #91DA66;
        overflow: hidden;
        border-radius: 100%;

        span {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            color: inherit;
            background-color: transparent;
        }
    }

    &__subtitle {
        font-size: 10px;
        color: $primaryBlue;
    }


    &__body {
        padding: 16px 20px;
    }

    &__list {
        padding: 0;
        margin: 0;
        list-style: none;
        color: #929292;
        font-size: 14px;
        line-height: 1;
    }

    &__link {
        position: relative;
        display: block;
        padding: 10px 20px 10px 40px;
        background-color: transparent;
        transition: background-color .2s ease;
        border-radius: 5px;
        color: #555555;

        .auth-user__icon {
            position: absolute;
            left: 15px;
            top: 50%;
            width: 15px;
            height: 15px;
            transform: translate(-50%, -50%);
            background: url('/assets/images/icons/profile.svg') no-repeat center/contain;

            &.profile {
                background-image: url('/assets/images/icons/profile.svg');
            }

            &.notice {
                background-image: url('/assets/images/icons/notice.svg');
            }

            &.dashboard {
                background-image: url('/assets/images/icons/dashboard.svg');
            }

            &.setting {
                background-image: url('/assets/images/icons/settings.svg');
            }

            &.transaction {
                background-image: url('/assets/images/icons/transaction.svg');
            }

            &.less {
                background-image: url('/assets/images/icons/less.svg');
            }

            &.add {
                background-image: url('/assets/images/icons/add.svg');
            }

            &.exit {
                background-image: url('/assets/images/icons/exit.svg');
            }

        }

        &:hover {
            background-color: $primaryBlue;
            color: #fff;

            .auth-user__icon {
                &.profile {
                    background-image: url('/assets/images/icons/profile-white.svg');
                }

                &.notice {
                    background-image: url('/assets/images/icons/notice-white.svg');
                }

                &.dashboard {
                    background-image: url('/assets/images/icons/dashboard-white.svg');
                }

                &.setting {
                    background-image: url('/assets/images/icons/settings-white.svg');
                }

                &.transaction {
                    background-image: url('/assets/images/icons/transaction-white.svg');
                }

                &.less {
                    background-image: url('/assets/images/icons/less-white.svg');
                }

                &.add {
                    background-image: url('/assets/images/icons/add-white.svg');
                }

                &.exit {
                    background-image: url('/assets/images/icons/exit-white.svg');
                }
            }

        }
    }

}

.slide-leave-active,
.slide-enter-active {
    transition: .4s;
}

.slide-enter, .slide-leave-active {
    right: -100%;
}

</style>
